import React, { useState, useEffect, useCallback, memo } from 'react';
import { isMobile } from 'react-device-detect';
import { MdEdit, MdDelete, MdAdd } from 'react-icons/md';
import Pagination from 'react-js-pagination';
import { useDispatch } from 'react-redux';

import { Form } from '@rocketseat/unform';
import { format } from 'date-fns';

import { toggleLoading, setCurrentPage } from '~/store/modules/main/actions';
import { toggleModal } from '~/store/modules/modal/actions';

import ReactSwitch from '../../components/ReactSwitch';
import SearchBox from '../../components/SearchBox';
import api from '../../services/api';
import FormEtapas from './form';
import { Container, FilterContainer } from './styles';

function Etapas() {
  const [activePage, setActivePage] = useState(1);
  const itemsPerPage = parseInt(global.window.innerHeight - 208) / 82;
  const [refresh, setRefresh] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [etapas, setEtapas] = useState([]);
  const [total, setTotal] = useState(0);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setCurrentPage('Etapas Processos Seletivos'));
  }, [dispatch]);

  const iconStyles = {
    marginLeft: 7,
    cursor: 'pointer',
  };

  const handlePageChange = useCallback(pageNumber => {
    setActivePage(pageNumber);
  }, []);

  const fetchData = useCallback(async () => {
    dispatch(toggleLoading(true));
    const { data } = await api.get(`etapa/${itemsPerPage}/${parseInt((activePage - 1) * itemsPerPage)}/${searchTerm}`);
    const { data: dados, total: qte } = data;
    const newData = dados.map(item => ({ ...item, permiteCoordenador: Boolean(item.permiteCoordenador) }));
    if (dados) {
      setTotal(qte);
      setEtapas(newData);
    }
    dispatch(toggleLoading(false));
  }, [activePage, dispatch, itemsPerPage, searchTerm]);

  useEffect(() => {
    fetchData();
  }, [fetchData, refresh]);

  const deleteItem = useCallback(async item => {
    const processo = {
      id: item,
      dataExclusao: new Date(),
      usuarioExclusao: null,
    };

    const response = await api.delete('etapa', { data: processo });
    if (response.data.status) {
      setRefresh(ref => !ref);
    }
  }, []);

  const showForm = useCallback(
    dataLoad => {
      dispatch(toggleModal(true, <FormEtapas close={toggleModal} data={{ dataLoad }} setRefresh={setRefresh} />, 'etapa', ''));
    },
    [dispatch],
  );

  const search = useCallback(value => {
    if (value.trim() !== '') {
      setEtapas([]);
      setActivePage(1);
      setSearchTerm(value.toLowerCase());
    } else {
      setSearchTerm('');
    }
  }, []);

  return (
    <Container>
      <FilterContainer>
        <SearchBox onSearch={search} />
        <button type="button" onClick={() => showForm({})}>
          <MdAdd size={24} color="#fff" />
        </button>
      </FilterContainer>
      <div className="table-responsive">
        <table className="table-outline mb-0 d-sm-table table table-hover">
          <thead className="thead-light">
            <tr>
              <th width={isMobile ? '45%' : '60%'}>Nome</th>
              <th width={isMobile ? '45%' : '18%'}>Permitir Coordenador</th>
              <th className="text-right">Ações</th>
            </tr>
          </thead>
          <tbody>
            {etapas &&
              etapas.map(item => (
                <tr key={item.id}>
                  <td>
                    <div>{item.nome}</div>
                    <div className="small text-muted">
                      <small>Id: {item.id} |</small>
                      <small> Data Cadastro: {format(new Date(item.dataCadastro), 'dd/MM/yyyy')}</small>
                    </div>
                  </td>
                  <td className="text-center">
                    <Form initialData={item}>
                      <ReactSwitch name="permiteCoordenador" textoLigado="Sim" textoDesligado="Não" disabled />
                    </Form>
                  </td>
                  <td>
                    <div className="btn-group" style={{ float: 'right' }}>
                      <MdEdit size={24} color="#5b5c65" style={iconStyles} onClick={() => showForm(item)} />
                      <MdDelete
                        size={24}
                        color="#e53935"
                        style={iconStyles}
                        onClick={() =>
                          global.window.confirm(`Tem certeza que deseja excluir este item: ( ${item.nome} )?`) &&
                          deleteItem(item.id)
                        }
                      />
                    </div>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
      <div className="pagination-container">
        <Pagination
          activePage={activePage}
          itemsCountPerPage={itemsPerPage}
          totalItemsCount={total}
          pageRangeDisplayed={isMobile ? 3 : 10}
          onChange={handlePageChange}
          prevPageText="Anterior"
          nextPageText="Próxima"
          firstPageText="Primeira"
          lastPageText="Última"
        />
      </div>
    </Container>
  );
}

export default memo(Etapas);
